module.exports = __webpack_public_path__ + "static/classes-9a84fac81063357758bf5bd1684cdb62.png";